module.exports = __webpack_public_path__ + "img/编组 11.807b5d96.png";